import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input } from "antd";
import { Button, Modal } from "react-bootstrap";
import { MuscleGroup } from "../../types/Entities";
import { useEffect } from "react";
import { TailSpin } from "react-loader-spinner";

type Props = {
  muscleGroup?: MuscleGroup;
  onSubmit?: (values: any) => void;
  onClose?: () => void;
  loading: boolean;
};

export default function MuscleGroupForm({
  onSubmit,
  onClose,
  muscleGroup,
  loading,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (muscleGroup)
      form.setFieldValue("muscleGroup", muscleGroup.muscleGroup);
  }, [muscleGroup, form]);

  return (
    <Form form={form} onFinish={onSubmit}>
      <Modal.Body>
        <Form.Item
          name="muscleGroup"
          label="Gruppo Muscolare"
          rules={[
            {
              required: true,
              message: "Il nome del Gruppo Muscolare è obbligatorio",
            },
          ]}
        >
          <Input placeholder="Nome Gruppo..." />
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button
          variant="light"
          size="sm"
          className="border"
          onClick={onClose}
          disabled={loading}
        >
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <span>Chiudi</span>
          )}
        </Button>
        <Button type="submit" variant="success" size="sm" disabled={loading}>
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <>
              <FontAwesomeIcon icon={faSave} />
              <span className="ms-2">Salva</span>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );
}
